module.exports = __webpack_public_path__ + "img/ecommerce-product-background-after.8d15fcb3.png";